import { IcoAdd } from "assets/icons";
import { Button, RegisterItem } from "components";
import { ModalBankAccountDelete } from "components/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPartnerUuid } from "services/auth";
import { deleteBankAccount, getBankAccounts } from "services/bank-account";
import { bankList } from "utils/bankList";
import styles from "./styles.module.scss";

export default function ManageBankAccountsPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [bankAccounts, setBankAccounts] = useState<any[]>([]);
	const [partnerId, setPartnerId] = useState("");

	const [showModalBankAccountDelete, setShowModalBankAccountDelete] =
		useState(false);
	const [selectedBankAccountId, setSelectedBankAccountId] =
		useState<string>("");

	const fetchData = async () => {
		const partnerUuid = (await getPartnerUuid()) || "";
		setPartnerId(partnerUuid);

		const result: any[] = (await getBankAccounts(partnerUuid || "")) || [];

		if (result) {
			result.sort((a, b) => {
				if (a.is_primary) return -1;
				if (b.is_primary) return 1;
				return 0;
			});
			setBankAccounts(result);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleEdit = (id: string) => {
		navigate(`/cadastro/contas/${id}/editar`);
	};

	const handleDelete = async (id: string) => {
		await deleteBankAccount(partnerId, id);
		await fetchData();
	};

	const getBankName = (bank_id: string) => {
		const bank = bankList.find((b) => b.value === bank_id);
		return bank ? bank.label : bank_id;
	};

	const formatAccountNumber = (account_number: string) => {
		if (!account_number) return "";
		if (account_number.includes("-")) return account_number; // já está formatado
		const len = account_number.length;
		if (len < 2) return account_number;
		return `${account_number.slice(0, len - 1)}-${account_number.slice(
			len - 1
		)}`;
	};

	return (
		<form className={styles.form}>
			<ModalBankAccountDelete
				open={showModalBankAccountDelete}
				onClose={() => setShowModalBankAccountDelete(false)}
				onAgree={() => {
					handleDelete(selectedBankAccountId);
					setShowModalBankAccountDelete(false);
				}}
			/>
			<div className={styles.container}>
				{bankAccounts.map((bankAccount) => {
					const hasBankData = bankAccount.bank_id && bankAccount.account_number;
					const title = hasBankData
						? getBankName(bankAccount.bank_id)
						: "Chave Pix";
					const subtitle = hasBankData
						? `${bankAccount.branch_id ?? ""}${"\u00A0".repeat(
								4
						  )}${formatAccountNumber(bankAccount.account_number ?? "")}`
						: bankAccount.pix_key || "";

					return (
						<RegisterItem
							key={bankAccount.id}
							title={title}
							subtitle={subtitle}
							onEdit={() => handleEdit(bankAccount.id)}
							label={bankAccount.is_primary ? "Principal" : undefined}
							onDelete={() => {
								setSelectedBankAccountId(bankAccount.id);
								setShowModalBankAccountDelete(true);
							}}
						/>
					);
				})}
				<div className={styles.addButtonWrapper}>
					<Button
						type="button"
						variant="outline"
						onClick={() => {
							navigate("/cadastro/contas/novo");
						}}
					>
						<div className={styles.addButton}>
							<IcoAdd />
						</div>
						Nova conta / PIX
					</Button>
				</div>
			</div>
			<div className={styles.buttonWrapper}>
				<Button type="button" onClick={() => navigate("/cadastro/finalizado")}>
					Concluir
				</Button>
			</div>
		</form>
	);
}
